import * as React from "react";
import { Text, TextVariant } from "../../../ui";

export enum HeadingAlign {
  LEFT = "LEFT",
  CENTER = "CENTER",
}

export const Heading: React.FC<{ align?: HeadingAlign }> = ({ align = HeadingAlign.LEFT, children }) => (
  <Text
    variant={TextVariant.CAPTION}
    className={`text-gray-400 uppercase tracking-wider ${align === HeadingAlign.CENTER ? "text-center" : ""}`}
    // Smaller than the readings, so the headings label the columns without competing with them.
    style={{ fontWeight: 600, fontSize: "0.65625rem" }}
  >
    {children}
  </Text>
);
